<template>
  <v-card v-if="userGroups.includes('Application Supervisors')" class="mb-4">
    <v-list-item
        class="warning"
        dark
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-hammer-screwdriver
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Admin Actions</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click.prevent="minimize = !minimize">
          <v-icon v-if="!minimize">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <div v-if="!minimize">
      <v-row class="px-4 pt-4">
        <v-col cols="12">
          <v-autocomplete
              v-model="manager"
              :items="managers"
              item-text="display_name"
              item-value="value"
              label="Application Manager"
              outlined
              required
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-card-subtitle class="pt-0 pb-0">Application Status</v-card-subtitle>
      <v-row class="px-4">
        <v-col
            cols="12"
            md="4"
            sm="4"
        >
          <v-checkbox
              v-model="isComplete"
              color="green"
              hide-details
              label="Completed"
          ></v-checkbox>
        </v-col>
        <v-col
            cols="12"
            md="4"
            sm="4"
        >
          <v-checkbox
              v-model="isWithdrawn"
              color="orange"
              hide-details
              label="Withdrawn"
          ></v-checkbox>
        </v-col>
        <v-col
            cols="12"
            md="4"
            sm="4"
        >
          <v-checkbox
              v-model="isDeclined"
              color="red"
              hide-details
              label="Declined"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
            color="primary"
            large
            text
            @click.stop="updateData()"
        >Save
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>
<script>
import {mapGetters} from "vuex";
import {errorNotification} from "@/components/utils";

export default {
  name: 'ApplicationActionsAdmin',
  props: {
    id: Number
  },
  data() {
    return {
      minimize: true,
      loading: false,
      application: {},
      isComplete: false,
      isWithdrawn: false,
      isDeclined: false,
      manager: null
    }
  },
  computed: {
    ...mapGetters({
      userGroups: 'auth/groups'
    }),
  },
  methods: {
    fetchData() {
      this.$axios.get('/applications/' + this.id + '/', {})
          .then((response) => {
            this.application = response.data
            this.isComplete = this.application.is_complete
            this.isWithdrawn = this.application.is_withdrawn
            this.isDeclined = this.application.is_declined
            this.manager = this.application.manager
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    fetchOptions() {
      this.$axios.options('/applications/' + this.id + '/')
          .then((response) => {
            let options = response.data
            // console.log(options)
            this.managers = options.actions.PUT.manager.choices
            // this.types = options.actions.POST.type.choices
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    updateData() {
      const data = {
        is_complete: this.isComplete,
        is_withdrawn: this.isWithdrawn,
        is_declined: this.isDeclined,
        manager: this.manager
      }
      this.loading = true
      this.$axios.patch('/applications/' + this.id + '/', data)
          .then(() => {
            this.fetchData()
            this.$store.dispatch('snackbar/info', 'Application updated')
            this.loading = false
          })
          .catch((error) => {
            errorNotification(error)
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
  mounted() {
    this.fetchOptions()
    this.fetchData()
  }
}
</script>